<template>
  <div id="main">
    <mv-full-page
      :isPointer="false"
      :isV="isV"video
      :pages="pageCount"
      :page.sync="currentPage"
      :isCache="true"
      height="calc(100% - 0.72rem)"
      :transition="{
        duration: '500ms', // 动画时长
        timingFun: 'ease', // 动画速度曲线
        delay: '0s', // 动画延迟
      }"
      @rollEnd="onRollEnd"
      :config="{
        disabled: this.localValue
      }"
    >
      <template #page1>
        <div class="video">
          <div class="video-container">
            <video class="video" ref="myVideo" :src="l30SeriesVideo"
                   muted autoplay loop
                   @contextmenu.prevent
                   controls playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"
                   :poster="l30SeriesVideo + '?x-oss-process=video/snapshot,t_0,f_jpg,m_fast'">
            </video>
          </div>
          <div class="copyright">
            广告审查批准文号:苏械广审(视)第270509-06477号 盆底康复治疗仪 医疗器械注册号:苏械注准20262090138<br/>
            请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
          </div>
        </div>
      </template>
      <template #page2>
        <div class="therapeuticInstrument">
          <img alt :src="require('@/assets/img/product/l30/diease-right.png')"/>
          <div class="about">
            <p>Lumina耀雅·盆底康复治疗仪</p>
            <p>对症修复盆底肌<br/>焕活私密紧弹润</p>
          </div>
          <div class="img-copyright">
            广告审查批准文号:苏械广审(文)第270509-06971号 盆底康复治疗仪 医疗器械注册号:苏械注准20262090138<br/>
            请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
          </div>
        </div>
      </template>
      <template #page3>
        <div class="video">
          <div class="video-container">
            <video class="video" ref="myVideo" :src="adaptiveProbeVideo"
                   muted autoplay loop
                   @contextmenu.prevent
                   playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"
                   :poster="adaptiveProbeVideo + '?x-oss-process=video/snapshot,t_0,f_jpg,m_fast'">
            </video>
          </div>
          <div class="title">
            <p>
              <span>专为亚洲女性研发的</span>&nbsp&nbsp&nbsp
              <span>零感自适应探头</span><span>™</span>
            </p>
          </div>
          <div class="copyright">
            广告审查批准文号:苏械广审(文)第270509-08230号 盆底康复治疗仪 医疗器械注册号:苏械注准20262090138<br/>
            请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
          </div>
        </div>
      </template>

    </mv-full-page>
  </div>
</template>

<script>
import '@/assets/css/animate.min.css';
import 'mv-full-page/lib-dist/mv-full-page.css';
import MvFullPage from 'mv-full-page';
import Vue from 'vue';
import directives from '@/utils/directives';

Vue.use(directives);
Vue.use(MvFullPage);

export default {
  data() {
    return {
      localValue: this.value,
      isV: true,
      currentPage: 1,
      pageCount: 3,
      l30SeriesVideo: `//download.wrightin.com/train_prepare_video/wrightin-home-l30.mp4`,
      adaptiveProbeVideo: `//download.wrightin.com/train_prepare_video/mobile-wrightin-probe.mp4`,
      medicalSiliconeVideo: `//download.wrightin.com/website/product-t20.mp4`
    };
  },
  props: {
    value: { //数据源（必填）
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$parent.$emit('rollInit');
  },
  methods: {
    onRollEnd(page) {
      this.$parent.$emit('rollPage', page);
      if (page === this.pageCount) {
        this.$parent.$emit('rollEnd');
      } else {
        this.$parent.$emit('rollTop');
      }
    },
  },
  watch: {
    value(val) {
      this.localValue = val;
    },
    currentPage(val) {
      if (val === 1) {
        this.localValue = false;
      }
    }
  },
  components: {

  },
};
</script>

<style lang="scss" scoped>
.full-page-wrapper {
  top: 0.72rem;

  // 强制第一页全屏
  /deep/ .all-page .page:nth-child(1) {
    height: calc(100% / 3 + 0.72rem) !important;
    margin-top: -0.72rem !important;
  }
}

.video {
  position: relative;
  width: 100%;
  height: 100%;

  > .video-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;

    > .video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  > .title {
    position: relative;
    bottom: 1.38rem;
    > p {
      display: flex;
      justify-content: center;
      font-size: 0.3rem;
      line-height: 0.78rem;
      font-weight: 500;
      > span {
        font-size: 0.56rem;
        font-weight: 500;
        color: #fff;
      }
      > span:nth-child(2) {
        /* 金色渐变：从浅金到深金 */
        background: linear-gradient(90deg, #D0B26B 0%, #E5C87F 25%, #F5D995 50%, #F9E2A8 100%);
        /* 核心属性：将背景裁剪到文字区域 */
        background-clip: text;
        /* 文字透明，显示渐变背景 */
        color: transparent;
      }
      > span:nth-child(3) {
        /* 金色渐变：从浅金到深金 */
        background: linear-gradient(90deg, #D0B26B 0%, #E5C87F 25%, #F5D995 50%, #F9E2A8 100%);
        /* 核心属性：将背景裁剪到文字区域 */
        background-clip: text;
        /* 文字透明，显示渐变背景 */
        color: transparent;
        font-size: 0.25rem;
        position: relative;
        bottom: 0.15rem;
      }
      margin-bottom: 0.66rem;
    }
  }

  > .copyright {
    position: absolute;
    bottom: 0.24rem;
    left: 0rem;
    width: 100%;
    font-weight: 400;
    font-size: 0.12rem;
    color: rgba(255, 255, 255, 0.64);
    line-height: 0.17rem;
    text-align: center;
    pointer-events: none;
  }
}

.therapeuticInstrument {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #DEE1F7 0%, #AEB4F2 100%);
  display: flex;
  align-items: center;
  > img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  // 悬浮放大
  //> img:hover {
  //  transform: scale(1.2);
  //}

  > .about {
    left: 2.6rem;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    > p:nth-child(1) {
      font-size: 0.3rem;
      color: #fff;
      font-weight: 500;
      width: 3.89rem;
    }

    > p {
      width: 3.92rem;
      font-weight: 500;
      margin-top: 0.2rem;
      font-size: 0.56rem;
      /* 金色渐变：从浅金到深金 */
      background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
      /* 核心属性：将背景裁剪到文字区域 */
      background-clip: text;
      /* 文字透明，显示渐变背景 */
      color: transparent;
    }
  }
}
</style>
